import "./About.css";

export default function About() {
  return (
    <section className="about">
      <h2>About Me</h2>
      <p>
        I'm <strong>SRINADH CHINTAKINDI</strong>, a full-stack developer, AI enthusiast, and cybersecurity learner deeply passionate about building secure, scalable, and intelligent digital solutions that make a real-world impact. My core expertise lies in the intersection of artificial intelligence, software engineering, ethical hacking, and system design.
      </p>

      <p>
        I specialize in web development using modern tools such as <strong>Flask, Django,  MySQL, HTML, CSS, JavaScript, React.js</strong>, and recently, I’ve been diving into <strong>Machine learning</strong> to build dynamic, responsive frontends. I take pride in building everything from scratch — from front-end design to database architecture, backend logic, and deployment. Whether it’s a blog system, shop management tool, or a real-time chat app, I focus on usability, efficiency, and robustness.
      </p>

      <p>
        One of my most notable projects is <strong>Urban ZoomIN</strong>, a hyperlocal commerce and smart city platform designed to connect users with nearby stores in real time. It features live store status updates, search and category filtering, admin controls, and plans for mobile responsiveness, notifications, and map integration. The platform serves as a decision-making tool for shoppers while empowering local shopkeepers.
      </p>

      <p>
        I’ve also developed a <strong>real-time one-on-one chat system</strong> with login functionality and message notifications between two users. Rather than relying on external notification tokens, I engineered a custom solution using user IDs to streamline communication within the app.
      </p>

      <p>
        Beyond software, I’ve ventured into the world of <strong>AI and ML</strong>. One standout project involves an Malicious URL prediction. It detects URL is malicious or not.
      </p>

      <p>
        I’m currently sharpening my skills in <strong>Artificial intelligence and Machine learning</strong>, participating in hands-on internships and training to understand the model implications of digital systems and secure coding practices. This knowledge helps me design safer and more resilient applications.
      </p>

      <p>
        In addition to technical development, I enjoy learning how to effectively communicate my work and progress. I’m actively exploring <strong>LinkedIn content writing</strong> to share my knowledge, projects, and personal growth with a broader community. My aim is not just to build products, but to tell stories around them and inspire others on similar paths.
      </p>

      <p>
        In short, I’m a developer, maker, and thinker who enjoys turning abstract ideas into working products. Whether I’m building a chat app, a smart store dashboard, an IoT solution, or a modern portfolio, I do it with passion, precision, and a sense of purpose.
      </p>
    </section>
  );
}
